import {replace} from 'react-router-redux';

export const redirect = path => (dispatch, getState) => {
    // compare route to prevent multiple redirect
    const {routing: {locationBeforeTransitions}} = getState();
    if (locationBeforeTransitions.pathname !== path) {
        dispatch(replace(path));
    }
};
